import { showLanguageModal } from "../modules/lang-modal";
import { modalInit, openElement } from "../modules/modal";
import { initHeader, initCategoryMenu } from "../modules/header";
import { initLazyVideoLoader } from "../modules/lazy-video-loader.js";
import { initCountdown } from "../modules/countdown.js";

if (import.meta.env.DEV) {
    // for local development, import the Tailwind CSS file to have HMR
    import("@/css/tailwind.css");
}

document.addEventListener("DOMContentLoaded", () => {
    modalInit();
    showLanguageModal();
    initHeader();
    initCategoryMenu();
    initLazyVideoLoader();
    if (typeof jQuery !== "undefined") {
        jQuery(document.body).on("added_to_cart", function () {
            openElement("fgt-mini-cart-drawer");
        });
    }
    initCountdown();
});
